import { useApi } from './useApi';

export function useUser() {
  const { fetchData, postData, putData, data, error, loading } = useApi();

  const getMyProfileApi = async () => {
    try {
      const result = await fetchData('/api/user?include=roles');
      return { success: true, data: result?.data || result };
    } catch (err) {
      return { success: false, error: err.message || 'Lỗi kết nối' };
    }
  };

  const updateMyProfileApi = async (payload) => {
    try {
      const result = await putData('/api/user', payload);
      return { success: true, data: result?.data || result };
    } catch (err) {
      return { success: false, error: err.message || 'Lỗi kết nối' };
    }
  };

  const createUserApi = async (credentials) => {
    try {
      const result = await postData('/api/users', credentials);
      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message
      };
    }
  };

  const updateUserApi = async (id, credentials) => {
    try {
      const result = await putData(`/api/users/${id}`, credentials);

      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message || 'Lỗi kết nối'
      };
    }
  };

  const getUsersApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/users', { params });

      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message || 'Lỗi kết nối'
      };
    }
  };

  const updateRolesApi = async (id, payload) => {
    try {
      const result = await postData(`/api/users/${id}/update-roles`, payload);
      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message || 'Lỗi kết nối'
      };
    }
  };

  return { createUserApi, getUsersApi, loading, updateUserApi, getMyProfileApi, updateMyProfileApi, updateRolesApi };
}
